import baseRequest from "../_core/baseRequest";

export default {
    // List equipment requests
    listEquipmentRequests: params => {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append("page", params.page);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.status) queryParams.append("status", params.status);
        if (params?.zoneManagementId)
            queryParams.append("zoneManagementId", params.zoneManagementId);
        if (params?.zoneId) queryParams.append("zoneId", params.zoneId);
        if (params?.startDate) queryParams.append("startDate", params.startDate);
        if (params?.endDate) queryParams.append("endDate", params.endDate);
        if (params?.searchText) queryParams.append("searchText", params.searchText);

        const queryString = queryParams.toString().replaceAll("+", "%20");
        return baseRequest.get(`/equipment-request/list${queryString ? `?${queryString}` : ""}`);
    },

    // Create equipment request
    createEquipmentRequest: params =>
        baseRequest.post(`/equipment-request/create`, {
            zoneId: params.zoneId,
            requesterName: params.requesterName,
            requesterPhone: params.requesterPhone,
            requesterTckn: params.requesterTckn,
            cityId: params.cityId,
            districtId: params.districtId,
            neighborhoodId: params.neighborhoodId,
            address: params.address,
            requestedEquipments: params.requestedEquipments
        }),

    // Approve equipment request
    approveEquipmentRequest: params => baseRequest.post(`/equipment-request/${params.id}/approve`),

    // Get equipment request details
    getEquipmentRequest: params => baseRequest.get(`/equipment-request/${params.id}`),

    // Download equipment request label (PDF)
    downloadEquipmentRequestLabel: params =>
        baseRequest.get(`/equipment-request/${params.id}/label`)
};
